<template>
  <div id="combinatorWrapper" :class="{ 'has-fixed-height': isEditing }">
    <edit-modal
      :wide="true"
      :caption="!isEditing ? 'Datasets genereren' : 'Geselecteerde datasets bewerken'"
      :isActive="isActive">

      <div class="columns">
        <div
          v-for="column in staticColumns"
          :key="column.id"
          class="column">

          <combinator-selector
            :column="column.column"
            :options="column.values"
            :multiple="!isEditing"
            @updateChanges="setChanges"
            @updateSelection="update">
          </combinator-selector>
        </div>
      </div>

      <div class="columns" :class="{ 'is-stuck-to-bottom': isEditing }">
        <div class="column">
          <save-buttons
            @save="confirm"
            @cancel="cancel">
          </save-buttons>
        </div>
      </div>
    </edit-modal>

    <div class="modal" :class="{ 'is-active': needsConfirmation }">
      <div class="modal-background"></div>

      <div class="modal-content">
        <article class="message is-warning">
          <div class="message-header">
            <p>Let op!</p>
          </div>

          <div class="message-body">
            <div class="columns">
              <div class="column">
                <p>Er worden {{ getNumRows() }} rijen gegenereerd met deze combinatie. Dit kan lang duren. Weet je zeker dat je deze rijen wilt opslaan?</p>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <save-buttons
                  @save="save"
                  @cancel="change"
                  saveCaption="Ja, opslaan"
                  saveClass="is-warning"
                  cancelCaption="Nee, combinaties wijzigen">
                </save-buttons>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'
import CombinatorSelector from '@/components/datasets/CombinatorSelector'

export default {
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    hasSelected: {
      type: Array,
      required: true
    }
  },
  components: {
    EditModal,
    SaveButtons,
    CombinatorSelector
  },
  data () {
    return {
      changes: [],
      selection: [],
      confirmed: false,
      needsConfirmation: false
    }
  },
  computed: {
    ...mapGetters({
      table: 'tables/table',
      bundle: 'bundles/bundle',
      columns: 'columns/columns'
    }),
    isEditing () {
      return this.hasSelected.length !== 0
    },
    staticColumns () {
      return this.columns.filter(x => !x.column.dynColumn)
    }
  },
  methods: {
    save () {
      if (this.isEditing) {
        this.$store.dispatch('tables/editCombinedDatasets', {
          changes: this.changes,
          table_id: this.table.id,
          bundle_id: this.bundle.id,
          datasets: this.hasSelected
        })

        this.changes = []
      } else {
        this.$store.dispatch('tables/combineDatasets', {
          tableId: this.table.id,
          bundleId: this.bundle.id,
          selection: this.selection,
          numRows: this.getNumRows()
        })

        this.selection = []
      }

      bus.$emit('clearValues')

      this.close()
    },
    update (payload) {
      const idx = this.selection.findIndex(x => x.columnId === payload.columnId)

      if (idx > -1) {
        this.selection[idx] = payload
      } else {
        this.selection.push(payload)
      }
    },
    cancel () {
      this.close()
    },
    change () {
      this.needsConfirmation = false
    },
    close () {
      this.needsConfirmation = false
      this.$emit('close')
    },
    confirm () {
      (this.getNumRows() > 100) ? this.needsConfirmation = true : this.save()
    },
    getNumRows () {
      return this.selection.reduce((total, column) => {
        return total * column.values.length
      }, 1)
    },
    setChanges (payload) {
      const idx = this.changes.findIndex(x => x.columnId === payload.columnId)

      if (idx === -1) {
        if (payload.value !== null) {
          this.changes.push(payload)
        }
      } else {
        !payload.value ? this.changes.splice(idx, 1) : this.changes[idx].value = payload.value
      }
    }
  }
}
</script>

<style scoped>
  .modal-content {
    width: 95%;
  }

  .column {
    border-right: 1px solid hsl(0, 0%, 86%);
  }

  .is-stuck-to-bottom {
    position: absolute;
    bottom: 25px;
  }

  .is-stuck-to-bottom .column {
    border: 0;
  }

  article {
    width: 50%;
    margin: 0 auto;
  }
</style>
